import LegalLayout, { Section } from "@/components/jobbkarta/LegalLayout";
import { CONTACT_EMAIL } from "@/components/jobbkarta/Footer";

const UPDATED = "12 oktober 2026";

export default function Cookies() {
  return (
    <LegalLayout title="Cookies och lagring i din webbläsare" updated={UPDATED} testid="page-cookies">
      <p>
        Här förklarar vi vilka cookies och liknande tekniker som används när du
        besöker Spontan.
      </p>

      <Section heading="Vi använder inga spårnings- eller marknadsföringscookies">
        <p>
          Spontan. sätter inga cookies för analys, spårning eller annonsering. Vi
          följer inte dig mellan webbplatser och säljer inte dina uppgifter.
        </p>
      </Section>

      <Section heading="Nödvändig lagring i din webbläsare">
        <ul className="list-disc space-y-1 pl-5">
          <li>
            <strong>Lokal lagring (local storage).</strong> Vi sparar din profil
            (t.ex. namn och erfarenhet som du själv fyllt i) lokalt på din enhet så
            att du slipper fylla i den varje gång. Uppgifterna stannar i din
            webbläsare och skickas inte till oss för lagring. Du kan när som helst
            rensa dem via din webbläsares inställningar.
          </li>
        </ul>
      </Section>

      <Section heading="Cookies från betalning (Stripe)">
        <p>
          När du genomför ett köp sker betalningen via Stripe. Stripe kan sätta
          egna nödvändiga cookies för att genomföra betalningen säkert och
          förhindra bedrägeri. Dessa styrs av Stripe enligt deras egen
          cookie- och integritetspolicy.
        </p>
      </Section>

      <Section heading="Hantera cookies">
        <p>
          Du kan blockera och radera cookies samt rensa lokal lagring via
          inställningarna i din webbläsare. Observera att vissa funktioner, som att
          komma ihåg din profil, då kan sluta fungera.
        </p>
      </Section>

      <Section heading="Kontakt">
        <p>
          Frågor om cookies? Mejla oss på{" "}
          <a className="font-medium text-emerald-700 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
